module.exports = __webpack_public_path__ + "static/card-project6-cdb05aa3618347759b9440758ee101f9.jpg";